<template>
	<div>
		<DetailTitle :title="'총 ' + completeCount + '회 예약'" />

		<DetailCardContainer>
			<ReservationListItem
				v-for="item in userReservationList"
				:key="item.NUM"
				:item="item"
				@initRender="initRender"
			/>
		</DetailCardContainer>

		<InfiniteLoading ref="infiniteLoading" @infinite="infinite" />
	</div>
</template>

<script>
import DetailTitle from '@/components/common/DetailTitle';
import DetailCardContainer from '@/components/common/DetailCardContainer';
import InfiniteLoading from '@/components/common/InfiniteLoading';
import ReservationListItem from './ReservationListItem';

export default {
	components: {
		DetailTitle,
		DetailCardContainer,
		InfiniteLoading,
		ReservationListItem,
	},
	data() {
		return {
			page: 1,
		};
	},
	computed: {
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userReservationList() {
			return this.$store.getters['reservationStore/userReservationList'];
		},
		completeCount() {
			const result = this.userReservationList.filter(
				el => el.STATUS_CODE === '1',
			);
			return result ? result.length : 0;
		},
	},
	created() {
		this.initUserReservationList();
	},
	methods: {
		async fetchUserReservationList() {
			const payload = {
				page: this.page,
				userId: this.userId,
			};

			return await this.$store.dispatch(
				'reservationStore/getUserReservationList',
				payload,
			);
		},
		initUserReservationList() {
			this.$store.dispatch('reservationStore/initUserReservationList');
		},
		infinite(state) {
			this.fetchUserReservationList().then(({ data }) => {
				if (data.code !== '00000' || data.page > data.totalPage) {
					this.page--;
					state.complete();
				}
				if (data.page <= data.totalPage) {
					this.page++;

					/**
					 * 데이터 가져오는 속도가 빨라서
					 * 스크롤시 무한 스크롤링 로딩 아이콘 노출 시간이 짧아서 보이지 않음.
					 * 임의로 가져오는 속도 늦춤.
					 */
					setTimeout(() => state.loaded(), 400);
				}
			});
		},
		initRender() {
			this.page = 1;
			this.initUserReservationList();
			this.$refs.infiniteLoading.resetInfiniteLoading();
		},
	},
};
</script>
